import { CmgUiUtilities } from '../components/common/cmg-ui-utils';
import { AddressModel } from './cmg-1003-common.model';
import { CreditReportType } from './credit-request-types.enum';

export class BorrowerCreditScoreModel {
  creditScoreMedian?: number;
  equifaxScore?: number;
  experianScore?: number;
  transUnionScore?: number;
  equifaxMissingScoreReason?: MissingCreditScoreReason;
  experianMissingScoreReason?: MissingCreditScoreReason;
  transUnionMissingScoreReason?: MissingCreditScoreReason;
}

export interface NonPersonInformation {
  isNonPerson: boolean;
  entityType: number;
  signer: string;
}

export class BorrowerModel {
  applicationId?: number;
  fileDataId?: number;
  borrowerId?: number;
  citizenship?: number;
  creditScores?: BorrowerCreditScoreModel;
  creditReportTypesRanForBorrower: CreditReportType[];
  dependentAges?: string;
  dependentsCount?: number;
  dob?: string;
  email?: string;
  firstName?: string;
  homePhone?: string;
  isDeleted?: boolean;
  isFirstTimeHomeBuyer?: boolean;
  lastCreditReportType?: CreditReportType;
  lastName?: string;
  mailingAddress?: AddressModel;
  maritalStatus?: number;
  useUnmarriedAddendum?: number;
  hasDomesticRelationship?: number;
  domesticRelationshipType?: number;
  domesticRelationshipOtherDesc?: string;
  domesticRelationshipState?: string;
  middleName?: string;
  mobile?: string;
  mobileCreditAuthorization?: Date;
  mobileEConsent?: Date;
  nickName?: string;
  nonPersonInformation: NonPersonInformation;
  okToPullCredit?: boolean;
  priorAddresses?: AddressModel[];
  presentAddressId: number;
  presentAddress?: AddressModel;
  sequenceNumber?: number;
  ssn?: string;
  suffix?: string;
  urlaAdditionalInfo?: string;
  workPhone?: string;
  isPrimaryBorrower?: boolean;

  /**
   * Creates a *untyped* borrower model to represent additional borrower,
   * if additional borrower is not present on the loan.
   * Note: Do not change the type to BorrowerModel, Akita does not
   * like it.
   * @param applicationId
   * @returns
   */
  static createNewUntypedAdditionalBorrower(applicationId: number, borrowerId: number) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const additionalBorrower: any = {};
    additionalBorrower.borrowerId = borrowerId; // can not be null b/c it is used as key by store
    additionalBorrower.applicationId = applicationId;
    additionalBorrower.maritalStatus = 0;
    additionalBorrower.citizenship = 0;
    additionalBorrower.isPrimaryBorrower = false;
    additionalBorrower.mailingAddress = new AddressModel();
    additionalBorrower.presentAddress = new AddressModel();
    additionalBorrower.presentAddressId = -CmgUiUtilities.getUniqueNumber();
    additionalBorrower.presentAddress.addressId = additionalBorrower.presentAddressId;
    additionalBorrower.creditScores = new BorrowerCreditScoreModel();
    additionalBorrower.priorAddresses = [];
    additionalBorrower.dependentAges = '';
    additionalBorrower.dob = null;
    additionalBorrower.isFirstTimeHomeBuyer = false;
    return additionalBorrower;
  }
}

export enum MissingCreditScoreReason {
  None = 0,
  Missing = 1,
  Frozen = 2,
  NotRequested = 3,
}

export enum NonPersonEntity {
  Select = 0,
  Corporation = 1,
  GovernmentEntity = 2,
  JointVenture = 3,
  LimitedLiabilityCompany = 4,
  LimitedPartnership = 5,
  NonProfitCorporation = 6,
  Partnership = 8,
  LandTrustAndBeneficiaryIsIndividual = 100,
  LivingTrust = 101,
  IllinoisLandTrust = 102,
  LandTrust = 103,
  NativeAmericanTribeOrTribalOrganization = 104,
}

export const nonPersonEntityOptions = [
  { label: 'Select', value: NonPersonEntity.Select },
  { label: 'Corporation', value: NonPersonEntity.Corporation },
  { label: 'Government Entity', value: NonPersonEntity.GovernmentEntity },
  { label: 'Joint Venture', value: NonPersonEntity.JointVenture },
  { label: 'Limited Liability Company', value: NonPersonEntity.LimitedLiabilityCompany },
  { label: 'Limited Partnership', value: NonPersonEntity.LimitedPartnership },
  { label: 'Non Profit Corporation', value: NonPersonEntity.NonProfitCorporation },
  { label: 'Partnership', value: NonPersonEntity.Partnership },
  { label: 'Land Trust and Beneficiary is Individual', value: NonPersonEntity.LandTrustAndBeneficiaryIsIndividual },
  { label: 'Living Trust', value: NonPersonEntity.LivingTrust },
  { label: 'Illinois Land Trust', value: NonPersonEntity.IllinoisLandTrust },
  { label: 'Land Trust', value: NonPersonEntity.LandTrust },
  { label: 'Native American Tribe or Tribal Organization', value: NonPersonEntity.NativeAmericanTribeOrTribalOrganization },
];
